export const CREATING_BADGE = 'Creating Badge';
export const RETRIEVING_BADGES = 'Retrieving Badges';
export const UPDATING_BADGE = 'Updating Badge';
export const DELETING_BADGE = 'Deleting Badge';
